import cx from 'clsx';
import { TextArea, TextAreaProps } from 'components/TextArea';
import { MENU_ITEM_MODAL_TEST_ID } from 'routes/MenuItemModal/MenuItemModalTestIds';
import React, { FC, HTMLAttributes, useEffect, useRef, useState } from 'react';
import styles from './OptionalTextArea.module.scss';

type OptionalTextAreaProps = TextAreaProps & {
  children: string; // the label string
  buttonProps?: HTMLAttributes<HTMLButtonElement>;
  buttonClassName?: string;
}

export const OptionalTextArea: FC<OptionalTextAreaProps> = ({ value, children, buttonProps, className, buttonClassName, ...props }) => {
  const [showInput, setShowInput] = useState<boolean>(!!value); // If we have an initial value then show the input immediately
  const [showSpecialInstructions, setShowSpecialInstructions] = useState<boolean>(!value);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  //If some external thing changes the value then set `showInput` and show the input
  useEffect(() => {
    // If there is a value but the input is hidden then open it
    if (!!value && !showInput) {
      setShowInput(true);
      setShowSpecialInstructions(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (textAreaRef.current && !value) {
      textAreaRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showInput]);

  return (
    <>
      {showSpecialInstructions && (
        <button
          data-testid={MENU_ITEM_MODAL_TEST_ID.specialInstructions}
          type="button"
          className={cx(styles.button, className, buttonClassName)}
          onClick={() => {
            setShowInput(true);
            setShowSpecialInstructions(false);
          }}
          {...buttonProps}
        >
          {children} +
        </button>
      )}

      <TextArea
        data-testid={MENU_ITEM_MODAL_TEST_ID.specialInstructionsText}
        className={cx(styles.input, { [styles.visible]: showInput }, className)}
        textAreaRef={textAreaRef}
        label={children}
        value={value}
        {...props}
      />
    </>
  );
};

